import {
  Box,
  Button,
  Typography,
  ListItemButton,
  IconButton,
  TextField,
  Checkbox,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GET_ALL_ADDRESS, GET_ALL_SHIPPING_ADDRESS } from "../../Utils/Queries";
import Loader from "../Common/Loader";
import AddAddress from "../../Account-Profile/Components/Address/AddAddress";

import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import { GET_COUNTRIES, GET_STATES, GET_CITY } from "../../Utils/Queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ADD_ADDRESS, ADD_SHIPPING_ADDRESS } from "../../Utils/Mutations";
import { useSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 400, md: 400, sm: 320, xs: 310 },
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "10px",
};

const Shipping = ({
  routePayment,
  setCartSummaryOptions = () =>
    console.warn("setCartSummaryOptions not provided"),
}) => {
  const [isSelected, setIsSelected] = useState(null);
  const [deliveryOption, setDeliveryOption] = useState("PICKUP");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showAddAddress, setShowAddAddress] = useState(false);

  const [getAddress, { loading: addressLoad, data: addressFetched , refetch}] =
    useLazyQuery(GET_ALL_SHIPPING_ADDRESS);

  useEffect(() => {
    getAddress();
    console.log("addedded:", addressFetched);
  }, []);

  const addressData = addressFetched?.fetchAllUserShippingAddress?.items;

  const handleSelect = (value) => {
    setDeliveryOption(value);
    localStorage.setItem("deliveryOption", value);
    setSelectedAddress(""); // clear previous address selection when switching
    setIsSelected(null);
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const [selectedCountry, setSelectedCountry] = useState("");

  const [stateID, setStateID] = useState("");

  const [cityID, setCityID] = useState("");

  const [selectedState, setSelectedState] = useState("");

  const [zip, setZip] = useState("");

  const [selectedCity, setSelectedCity] = useState("");

  const [countryID, setCountryID] = useState(null);

  const [address, setAddress] = useState("");

  const [address2, setAddress2] = useState("");

  const [phoneNo, setPhone] = useState("");

  // ========QUERIES===========================================================================================================================
  const [getCountries, { data }] = useLazyQuery(GET_COUNTRIES);
  const [getState, { loading: stateLoad, error: statError, data: stateData }] =
    useLazyQuery(GET_STATES);
  const [getCity, { loading: cityLoad, error: cityError, data: cityData }] =
    useLazyQuery(GET_CITY);

  const { firstName, lastName, phone } = useSelector(
    (state) => state.user?.user.profile
  );

  // ======ALERT FNC =================================================================================================
  const { enqueueSnackbar } = useSnackbar();
  const handleAlert = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [checked, setChecked] = React.useState(false);

  const handleChange2 = (event) => {
    setSelectedCountry(event.target.value);
  };
  const handleChange = (event) => {
    setSelectedState(event.target.value);
  };
  const handleChange3 = (event) => {
    setSelectedCity(event.target.value);
  };

  const handleChecked = (event) => {
    setChecked(event.target.checked);
  };

  // =======GET COUNTRIES , STATE, CITY===============================================================================================

  useEffect(() => {
    getCountries();
    getState({
      variables: {
        country: countryID,
      },
    });
    getCity({
      variables: {
        state: stateID,
      },
    });
  }, [countryID, stateID]);

  // ADD ADDRESS MUTATION ===============================================================================================================

  const [addAddress, { loading: addLoading }] =
    useMutation(ADD_SHIPPING_ADDRESS);

  const handleAddAddress = async () => {
    handleClose();
    await addAddress({
      variables: {
        firstName,
        lastName,
        // country: countryID,
        state: stateID,
        city: cityID,
        addressOne: address,
        addressTwo: address2,
        zipCode: zip,
        phone: phone ? phone : phoneNo,
        isDefault: checked,
      },
    })
      .then((response) => {
        refetch()
        getAddress();
        handleAlert(`Address added successfully`, "success");
      })
      .catch((err) => {
        handleAlert(`${err.message}`, "error");
      });
  };

  return (
    <>
      {addressLoad && <Loader />}

      <Box sx={{ mt: 3, pb: 3 }}>
        <Typography sx={{ color: "#333", fontSize: "16px", fontWeight: 500 }}>
          Select Delivery Option
        </Typography>

        {/* Home Delivery */}
        <Box
          onClick={() => {
            setCartSummaryOptions((prev) => ({
              ...prev,
              deliveryOption: "HOME",
            }));
            handleSelect("HOME");
          }}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: deliveryOption === "HOME" ? "#EBDCEF" : "#f8f7f7",
            py: 2,
            px: 2,
            mt: 2,
            border: deliveryOption === "HOME" && "1px solid #2E1834",
            borderRadius: "2px",
            cursor: "pointer",
          }}
        >
          <Box sx={{ display: "flex", columnGap: 2, alignItems: "center" }}>
            <Box
              sx={{
                borderRadius: "50%",
                width: deliveryOption === "HOME" ? "8px" : "20px",
                height: deliveryOption === "HOME" ? "8px" : "20px",
                border:
                  deliveryOption === "HOME"
                    ? "6px solid #2E1834"
                    : "1px solid #ccc",
              }}
            ></Box>
            <Typography
              sx={{ color: "#1a1a1a", fontWeight: 500, fontSize: "14px" }}
            >
              Home Delivery
            </Typography>
          </Box>
        </Box>

        {/* Pickup */}
        <Box
          onClick={() => {
            setCartSummaryOptions((prev) => ({
              ...prev,
              deliveryOption: "PICKUP",
              shippingAddressId: null,
            }));
            handleSelect("PICKUP");
            localStorage.removeItem("shipto");
          }}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: deliveryOption === "PICKUP" ? "#EBDCEF" : "#f8f7f7",
            py: 2,
            px: 2,
            mt: 2,
            border: deliveryOption === "PICKUP" && "1px solid #2E1834",
            borderRadius: "2px",
            cursor: "pointer",
          }}
        >
          <Box sx={{ display: "flex", columnGap: 2 }}>
            <Box
              sx={{
                borderRadius: "50%",
                width: deliveryOption === "PICKUP" ? "8px" : "20px",
                height: deliveryOption === "PICKUP" ? "8px" : "20px",
                border:
                  deliveryOption === "PICKUP"
                    ? "6px solid #2E1834"
                    : "1px solid #ccc",
              }}
            ></Box>
            <Typography
              sx={{ color: "#1a1a1a", fontWeight: 500, fontSize: "14px" }}
            >
              Pick up
            </Typography>
          </Box>
        </Box>

        {/* Show address list only if Home is selected */}
        {deliveryOption === "HOME" && (
          <Box mt={2}>
            {addressData &&
              addressData.map((item, index) => (
                <ListItemButton
                  selected={isSelected == index + 1}
                  onClick={() => {
                    setCartSummaryOptions((prev) => ({
                      ...prev,
                      shippingAddressId: item._id,
                    }));
                    setSelectedAddress(item);
                    setIsSelected(index + 1);
                    localStorage.setItem("shipto", item._id);
                  }}
                  key={index}
                  sx={{
                    my: 2,
                    px: 2,
                    borderRadius: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    boxShadow: "0px 4px 60px 0px rgba(4, 6, 15, 0.05)",
                    "&.Mui-selected": {
                      border: "1px solid #2E1834",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      sx={{ fontWeight: 500, fontSize: "14px", color: "#333" }}
                    >
                      {`${item?.firstName} ${item?.lastName}`}
                    </Typography>
                    <Typography
                      sx={{ fontWeight: 500, fontSize: "14px", color: "#333" }}
                    >
                      {item?.addressOne}
                    </Typography>
                    <Typography
                      sx={{ fontWeight: 300, fontSize: "12px", color: "#333" }}
                    >
                      {item?.phone}
                    </Typography>
                  </Box>
                  <Box>
                    {item?.isDefault && (
                      <Typography sx={{ color: "#5C3069", fontSize: "12px" }}>
                        (Default)
                      </Typography>
                    )}
                  </Box>
                </ListItemButton>
              ))}

            <Button onClick={handleOpen}>Add Address</Button>

            <Box mt={2}>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 500,
                        color: "#333",
                        fontSize: "20px",
                      }}
                    >
                      Shipping Address
                    </Typography>
                    <IconButton onClick={handleClose}>
                      <CloseIcon sx={{ color: "#333" }} />
                    </IconButton>
                  </Box>
                  <Box sx={{ mt: 3 }}>
                    <Typography
                      sx={{
                        color: "#4d4d4d",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      {" "}
                      Address 1
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Address"
                      margin="normal"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      InputProps={{
                        style: {
                          fontSize: "13px",
                          borderRadius: "8px",
                          offset: " 1px solid #f2f2f2",
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        color: "#4d4d4d",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      {" "}
                      Address 2
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Address"
                      margin="normal"
                      value={address2}
                      onChange={(e) => setAddress2(e.target.value)}
                      InputProps={{
                        style: {
                          fontSize: "13px",
                          borderRadius: "8px",
                          offset: " 1px solid #f2f2f2",
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        color: "#4d4d4d",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      {" "}
                      Phone
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Phone"
                      margin="normal"
                      value={phoneNo}
                      onChange={(e) => {
                        // Remove non-digit characters, including spaces
                        const digitsOnly = e.target.value.replace(/\D/g, "");
                        // Limit to 11 digits
                        if (digitsOnly.length <= 10) {
                          setPhone(digitsOnly);
                        }
                      }}
                      inputProps={{
                        inputMode: "numeric", // improves UX on mobile
                        maxLength: 11, // limits physical typing
                        pattern: "[0-9]*", // optional: for some mobile browsers
                      }}
                      InputProps={{
                        style: {
                          fontSize: "13px",
                          borderRadius: "8px",
                          offset: " 1px solid #f2f2f2",
                        },
                      }}
                    />
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Select
                          fullWidth
                          value={selectedCountry}
                          onChange={handleChange2}
                          sx={{
                            fontSize: "13px",
                            // border: "0.5px solid #671E78",

                            borderRadius: "10px",
                          }}
                          inputProps={{
                            "aria-label": "Without label",
                            style: {
                              color: "#2B2B2B",
                              fontSize: "13px",
                              fontWeight: 600,
                              mt: 1.5,
                            },
                          }}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            Country
                          </MenuItem>
                          {data?.getAllCountries?.items.map(({ name, _id }) => (
                            <MenuItem
                              value={name}
                              onClick={(e) => {
                                setCountryID(_id);
                                setSelectedState("");
                                setSelectedCity("");
                              }}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <Select
                          fullWidth
                          value={selectedState}
                          onChange={handleChange}
                          sx={{
                            fontSize: "13px",
                            // border: "0.5px solid #671E78",

                            borderRadius: "10px",
                          }}
                          inputProps={{
                            "aria-label": "Without label",
                            style: {
                              color: "#2B2B2B",
                              fontSize: "13px",
                              fontWeight: 600,
                              mt: 1.5,
                            },
                          }}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            {stateLoad ? "State Loading" : "State"}
                          </MenuItem>
                          {stateData?.fetchStates?.items.map(
                            ({ name, _id }) => (
                              <MenuItem
                                value={name}
                                sx={{
                                  p: 1,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                onClick={(e) => {
                                  setStateID(_id);
                                  setSelectedCity("");
                                }}
                              >
                                {name}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <Select
                          fullWidth
                          value={selectedCity}
                          onChange={handleChange3}
                          sx={{
                            fontSize: "13px",
                            // border: "0.5px solid #671E78",

                            borderRadius: "10px",
                          }}
                          inputProps={{
                            "aria-label": "Without label",
                            style: {
                              color: "#2B2B2B",
                              fontSize: "13px",
                              fontWeight: 600,
                              mt: 1.5,
                            },
                          }}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            {cityLoad ? "City Loading" : "City"}
                          </MenuItem>
                          {cityData?.fetchCities?.items.map(({ name, _id }) => (
                            <MenuItem
                              value={name}
                              sx={{
                                p: 1,
                                display: "flex",
                                alignItems: "center",
                              }}
                              onClick={(e) => {
                                setCityID(_id);
                              }}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <TextField
                          type="number"
                          fullWidth
                          value={zip}
                          onChange={(e) => setZip(e.target.value)}
                          placeholder="Zip code"
                          InputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                            style: {
                              mt: 1.5,
                              fontSize: "13px",
                              borderRadius: "8px",
                              offset: " 1px solid #f2f2f2",
                              // Replace with your desired font family
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Box sx={{ mt: 2 }}>
                      <Box>
                        <Checkbox checked={checked} onChange={handleChecked} />
                        <Typography variant="caption">
                          Make this as the default shipping address
                        </Typography>
                      </Box>
                      <Button
                        disabled={!selectedCity || !zip}
                        variant="contained"
                        fullWidth
                        onClick={handleAddAddress}
                        sx={{ borderRadius: "100px", mt: 2 }}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Modal>
            </Box>

            {/* <Link to="/account/address">
                <Button>Add Address</Button>
              </Link> */}
          </Box>
        )}

        <Button
          disabled={
            !deliveryOption || (deliveryOption === "HOME" && !selectedAddress)
          }
          onClick={routePayment}
          variant="contained"
          sx={{
            color: "#fff",
            mt: 4,
            borderRadius: "100px",
            padding: "12px 18px",
          }}
          fullWidth
        >
          Proceed
        </Button>
      </Box>
    </>
  );
};

export default Shipping;
